import { render, staticRenderFns } from "./BasePostCodeInput.vue?vue&type=template&id=089ceef6&scoped=true&"
import script from "./BasePostCodeInput.vue?vue&type=script&lang=ts&"
export * from "./BasePostCodeInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089ceef6",
  null
  
)

export default component.exports